import get from "lodash/get";
import React from "react";
import { useSelector } from "react-redux";
import { getDate } from "../utils";

export const TopBarDate = () => {
  const publisherAttributes = useSelector((state) => get(state, ["qt", "config", "publisher-attributes"]));
  const langCode = get(publisherAttributes, ["lang"], "en");

  return <>{getDate(langCode)}</>;
};
